// isolating blue unread dot into own component

import React from 'react';

const UnreadDot = () => <div className="unread-dot" />;

export default UnreadDot;
